/**
 * 非 critical 图标（menu / my / header / async-icon 目录）。
 * 静态并入主图，避免单独拆出 async-icon chunk。
 */
import '../../async-icon';

export function ensureAsyncIcons(): Promise<unknown> {
  return Promise.resolve();
}
